/**
 * TanStack Query hooks for `commission-preview`. Thin wrappers over ./api.
 * Keys rooted at ['commission-preview']; mutations invalidate the list.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	commissionPreviewQueryKeys,
	type CreateCommissionPreviewBody,
	type ListCommissionPreviewResponse,
	type CommissionPreviewRow,
} from "./api";

export function useCommissionPreviewList(): UseQueryResult<
	ListCommissionPreviewResponse,
	Error
> {
	return useQuery({
		queryKey: commissionPreviewQueryKeys.list(),
		queryFn: list,
	});
}

export function useCommissionPreviewCreate(): UseMutationResult<
	CommissionPreviewRow,
	Error,
	CreateCommissionPreviewBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: commissionPreviewQueryKeys.all });
		},
	});
}

export function useCommissionPreviewDelete(): UseMutationResult<
	{ removed: boolean },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: commissionPreviewQueryKeys.all });
		},
	});
}
